import React, { Component } from "react";

import { ListingContext } from "../../Context";

import { Title } from "../../utils/consts";

import "./googleEmbedMap.css";
export default class GoogleEmbedMap extends Component {
  render() {
    return (
      <ListingContext.Consumer>
        {listingContext => {
          const listing = listingContext.listing || {};
          const location = listing.location || {};
          const address = `${location.streetNumberText} ${
            location.streetName
          }, ${location.city}, ${location.province}`;
          const loc = escape(address).replace(",", /%2C/g);
          const src = `//www.google.com/maps/embed/v1/place?q=${loc}
        &zoom=14
        &key=AIzaSyD-i9OsunwYMYn7FVwCc75bAGsrnph6Hj4
        &attribution_source=${Title}`;
          return (
            <iframe
              title={`${Title} Google Map`}
              id="googleEmbedMaps"
              className="map"
              src={`${src}`}
              width="100%"
              frameBorder="0"
              allowFullScreen={true}
            />
          );
        }}
      </ListingContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/googleEmbedMap/googleEmbedMap.js